// File: frontend/src/utils/techFacts.js

const facts = [
  "The GIF format was invented in 1987, two years before the World Wide Web.",
  "JPEG stands for 'Joint Photographic Experts Group', the committee that created the standard.",
  "The first image ever uploaded to the web was a parody photo of a band called Les Horribles Cernettes.",
  "WebP was developed by Google to create smaller, better-looking images that make the web faster.",
  "PNG was created as an improved, non-patented replacement for GIF.",
  "The most expensive photograph ever sold is 'Phantom' by Peter Lik, selling for $6.5 million.",
  "Digital images are made of pixels. The word 'pixel' is a combination of 'picture' and 'element'.",
  "The first digital camera weighed 8 pounds (3.6 kg) and took 23 seconds to record a photo.",
  "Billions of images are shared online every day across the internet.",
  "SVG images are math-based, meaning you can scale them infinitely without losing quality.",
  "The first photograph ever taken was captured in France in 1826 by Joseph Nicéphore Niépce.",
  "The earliest color photograph was created in 1861 using three black-and-white images with color filters.",
  "The first digital image was scanned in 1957 from a photograph of a baby by Russell Kirsch.",
  "Some of the earliest image transmissions over computer networks happened in the early 1970s, before the web existed.",
  "Bitmap (BMP) was one of the earliest digital image formats used in Microsoft Windows.",
  "NASA transmitted the first images from space in the 1960s using analog signals converted to digital.",
  "A single 4K image contains over 8 million pixels.",
  "RAW images store sensor data without processing, which is why photographers prefer them for editing.",
  "The PNG format supports 16 million colors, compared to GIF’s limit of 256.",
  "Lossless image formats can be recompressed multiple times without degrading quality.",
  "The human eye can distinguish about 10 million different colors.",
  "The first selfie was taken in 1839 using a daguerreotype camera.",
  "Image metadata (EXIF) can store camera model, location, and even exposure settings.",
  "Web browsers once supported fewer than five image formats in the early 1990s.",
  "Image compression was critical for the rise of the web because early internet speeds were extremely slow."
];

export const getRandomFact = () => {
  const randomIndex = Math.floor(Math.random() * facts.length);
  return facts[randomIndex];
};